// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { FormItem, useWatchForm } from '@/components';
import { InputNumber, Select } from '@/ui';
import FormSectionHeader from '../FormSectionHeader/FormSectionHeader';
import { StyledFormSectionGrid } from '../Styled';

// Helpers
import { DeliverySettingsFormFields, TDeliverySettingsFormSectionProps } from '../../helpers';
import { useDeliverySettingsFormRules } from '../../hooks';

const UPSFormSection: FC<TDeliverySettingsFormSectionProps> = ({ formInstance, americanStates, canadianStates }) => {
  const { t } = useTranslation(['common']);

  const isUPSEnabled = useWatchForm(
    [DeliverySettingsFormFields.UPS_DELIVERY, DeliverySettingsFormFields.IS_ENABLED],
    formInstance,
  );

  const rules = useDeliverySettingsFormRules(formInstance);

  const handleToggleUPSDelivery = () => formInstance.validateFields();

  return (
    <div>
      <FormSectionHeader
        title={t('ups')}
        rules={rules.upsDelivery[DeliverySettingsFormFields.IS_ENABLED]}
        fieldName={[DeliverySettingsFormFields.UPS_DELIVERY, DeliverySettingsFormFields.IS_ENABLED]}
        onToggle={handleToggleUPSDelivery}
      />

      <StyledFormSectionGrid>
        <FormItem
          name={[DeliverySettingsFormFields.UPS_DELIVERY, DeliverySettingsFormFields.PRICE]}
          label={t('delivery_ups_price_label')}
          rules={rules.upsDelivery[DeliverySettingsFormFields.PRICE]}
        >
          <InputNumber disabled={!isUPSEnabled} placeholder={t('delivery_ups_price_placeholder')} />
        </FormItem>
        <FormItem
          label={t('excluded_states_usa_label')}
          name={[DeliverySettingsFormFields.UPS_DELIVERY, DeliverySettingsFormFields.EXCLUDED_STATES_USA]}
        >
          <Select
            disabled={!isUPSEnabled}
            options={americanStates}
            isMultiselect
            placeholder={t('excluded_states_usa_placeholder')}
          />
        </FormItem>
        <FormItem
          label={t('excluded_states_canada_label')}
          name={[DeliverySettingsFormFields.UPS_DELIVERY, DeliverySettingsFormFields.EXCLUDED_STATES_CANADA]}
        >
          <Select
            disabled={!isUPSEnabled}
            options={canadianStates}
            isMultiselect
            placeholder={t('excluded_states_canada_placeholder')}
          />
        </FormItem>
      </StyledFormSectionGrid>
    </div>
  );
};

export default UPSFormSection;
